import {escapeHtmlSymbols} from "../atUtils";

export default function EmptyHighlighter()
{
}

EmptyHighlighter.prototype.highlightTokens = function( text )
{
    return escapeHtmlSymbols(text);
};



// WEBPACK FOOTER //
// ./web/js/util/EmptyHighlighter.js